<template>
  <el-carousel :height="`${height}px`" v-if="tableData.length" :interval="5000" arrow="always">
    <el-carousel-item v-for="item in tableData" :key="item">
      <div class="pool">
        <div class="pool__name">{{ item.name }}</div>
        <FlowPoolEchart :info="item" />
        <FlowPoolInfo :info="item" />
      </div>
    </el-carousel-item>
  </el-carousel>
  <div v-else class="null__data">
    <img src="https://bsj-card.oss-cn-shenzhen.aliyuncs.com/upload/2023-10-08/1696731583831.jpg" />
    <p>暂无数据</p>
  </div>
</template>
<script>
import FlowPoolEchart from "./flowPoolEchart.vue";
import FlowPoolInfo from "./flowPoolInfo.vue";
export default {
  name: "flowPool",
  props: {
    height: {
      type: Number,
      default:400
    }
  },
  components: {
    FlowPoolEchart,
    FlowPoolInfo
  },
  data () {
    return {
      tableData:[],
    }
  },
  created () {
    this.getData();
  },
  methods: {
    async getData () {
      try{
        const { code, msg, data } = await this.$API.getTrafficInfo();
        if (code !== 0) throw { msg };
        console.log(data);
        this.tableData = data || [{}];
      } catch ({ msg }){
        this.$message({
          type: 'warning',
          message:msg
        });
      }
      
    }
  }
}
</script>
<style lang="scss" scoped>
.pool{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: calc(100% - 34px);
  padding: 20px;
  box-sizing: border-box;
  &__name{
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }
}
.null__data{
  width: 100%;
  height: 90%;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  color: #FFF;
  align-items: center;
  justify-content: center;
  align-content: center;
  >img{
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
  }
  >p{
    width: 100%;
  }
}
</style>